module.exports = __webpack_public_path__ + "summernote.6e72b5d181d3c1793e71.eot";


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/assets/vendors/base/fonts/summernote/summernote.eot
// module id = ../../../../../src/assets/vendors/base/fonts/summernote/summernote.eot
// module chunks = styles